class Acc {

  constructor(acc) {
    if (acc) {
      this.acc = acc
      this.init()
    }
  }


  init() {
    const triggers = this.acc.querySelectorAll('.acc__item .acc__title');

    triggers.forEach((trigger) => {
      const item = trigger.parentNode;
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        item.classList.contains('acc__item--expanded') ?
          this.collapseItem(item) :
          this.expandItem(item);
      });
    })
  }


  collapseItem(item) {
    item.classList.remove('acc__item--expanded');
  }

  expandItem(item) {
    item.classList.add('acc__item--expanded');
  }

  collapseItems() {
    const allItems = this.acc.querySelectorAll('.acc__item');
    allItems.forEach(item => item.classList.remove('acc__item--expanded'))
  }


  expandItems() {
    const allItems = this.acc.querySelectorAll('.acc__item');
    allItems.forEach(item => item.classList.add('acc__item--expanded'))
  }

}


export default Acc;